var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHandover = function SvgHandover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      boxShadow: "0 0 7px #ccc",
      borderRadius: 10,
      margin: 10
    },
    viewBox: "0 0 52 52"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "#fff",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 0.9,
    d: "M37.25 9.352h2.7v8.095h-8.104v-2.7h2.535a.45.45 0 0 0 .263-.815A14.84 14.84 0 0 0 26 11.15c-8.188 0-14.85 6.662-14.85 14.85 0 3.95 1.555 7.535 4.079 10.197a.45.45 0 0 0 .762-.196c1.16-4.445 5.2-7.747 10.009-7.747s8.85 3.293 10.01 7.747a.45.45 0 0 0 .762.195c2.417-2.56 3.957-5.973 4.07-9.747h2.701C43.304 35.922 35.528 43.55 26 43.55c-9.678 0-17.55-7.872-17.55-17.55S16.323 8.45 26 8.45c3.827 0 7.515 1.263 10.53 3.529a.45.45 0 0 0 .72-.36zm-18.889 29.1a.45.45 0 0 0 .224.397c2.187 1.267 4.713 2 7.416 2s5.23-.733 7.416-2a.45.45 0 0 0 .224-.398c-.081-4.14-3.467-7.497-7.64-7.497-4.172 0-7.558 3.346-7.64 7.497Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M31.406 22.399a5.404 5.404 0 1 0-10.811-.002 5.404 5.404 0 0 0 10.81.002ZM26 24.204a1.81 1.81 0 0 1-1.805-1.805c0-.989.806-1.805 1.805-1.805.989 0 1.805.806 1.805 1.805 0 .989-.816 1.805-1.805 1.805Z"
  })));
};
export default SvgHandover;